import ICreateVeiculoDTO from '../dtos/ICreateVeiculoDTO'
import ETipoVeiculo from '../entities/ETipoVeiculo'
import IVeiculosRepository from '../repositories/IVeiculosRepository'

export interface ICreateVeiculos {
  execute(params: ICreateVeiculoDTO): Promise<void>
}

export default class CreateVeiculos implements ICreateVeiculos {
  constructor(private readonly veiculoRepository: IVeiculosRepository) {}

  public async execute({
    crlv_imagem_completa,
    tipo,
    tipo_carreta_id,
    frotista_id,
  }: ICreateVeiculoDTO): Promise<void> {
    if (tipo !== ETipoVeiculo.CARRETA && tipo !== ETipoVeiculo.CAVALO) {
      throw new Error(`Tipo de veículo ${tipo} não existe!`)
    }
    if (tipo === ETipoVeiculo.CARRETA && !tipo_carreta_id) {
      throw new Error(
        'O ID do tipo carreta não foi informado, por favor tente novamente!',
      )
    }
    await this.veiculoRepository.create({
      crlv_imagem_completa,
      tipo,
      tipo_carreta_id,
      frotista_id,
    })
  }
}
